import _defineProperty from "@babel/runtime/helpers/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import { normalize } from 'normalizr';
import { GET_LIST_SUCCESS } from '../actions/constants';
import reducersGenerator from './generator';
import { cardSchema } from '../schemas/cardAvailability';

var isEqual = require('fast-deep-equal');

var mergeIntoBag = function mergeIntoBag() {
  var bag = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var entities = arguments.length > 1 ? arguments[1] : undefined;

  var returnedBag = _objectSpread({}, bag);

  for (var id in entities) {
    if (!Object.prototype.hasOwnProperty.call(entities, id)) {
      // eslint-disable-next-line no-continue
      continue;
    }

    if (!Object.prototype.hasOwnProperty.call(returnedBag, id)) {
      returnedBag[id] = entities[id];
    } else if (!isEqual(returnedBag[id], entities[id])) {
      returnedBag[id] = Object.assign({}, returnedBag[id], entities[id]);
    }
  }

  return returnedBag;
};

var availabilities = reducersGenerator({
  name: 'availabilities',
  surchargeReducer: function surchargeReducer() {
    var obj = {};

    obj[GET_LIST_SUCCESS] = function (state, action) {
      var _action$query = action.query,
          centerId = _action$query.centerId,
          practitionerId = _action$query.practitionerId;
      var item = {
        id: "".concat(centerId, "_").concat(practitionerId),
        availabilities: action.payload.items
      };
      var normalized = normalize(item, cardSchema);
      var entities = normalized.entities;
      var data = mergeIntoBag(state.data, entities);
      return _objectSpread(_objectSpread({}, state), {}, {
        isLoading: false,
        error: null,
        data: data
      });
    };

    return obj;
  }
});
export default availabilities;
//# sourceMappingURL=availabilities.js.map